export default ({
  formComponents
}) => ({
  root: {
    border: 0,
    padding: 0,
    marginBottom: formComponents.container.marginBottom
  },
  inline: {
    display: 'inline'
  },
  block: {
    display: 'block',
    margin: [10, 0]
  },
  inlineBlock: {
    display: 'inline-block'
  }
});
